export default __webpack_public_path__ + "static/media/Hair_16_F_C5.df5d8d58.svg";